// extracted by mini-css-extract-plugin
module.exports = {"loading":"Videos_loading__tWlnD","wrapper":"Videos_wrapper__pVAmj","scrollWrapper":"Videos_scrollWrapper__C5Heu","scrollButtonsWrapper":"Videos_scrollButtonsWrapper__rYu6W"};